export default __webpack_public_path__ + "static/media/toast-icon.e984bba1.svg";